import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { debounce, defer } from 'lodash';

export default class ResizeScrollWatcher extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      firstScroll: false,
    };
  }

  componentDidMount() {
    this.node = $(ReactDOM.findDOMNode(this.props.chart));

    this.content = this.node.find('.timeline-content-outer');
    this.rowStickyHeaders = this.node.find('.timeline-pivot-row-headings');
    this.scaleStickyHeader = this.node.find('.timeline-pivot-scale-header');
    this.stickyCorner = this.node.find('.timeline-pivot-sticky-corner');

    this.debouncedOnResize();
    this.onContentScroll(this.content);
    this.onMouseWheelScroll(this.rowStickyHeaders);
    this.onMouseWheelScroll(this.scaleStickyHeader);
    this.slideIntoPlace();
    this.props.handleResize();
  }

  slideIntoPlace() {
    const contentScrollLeft = this.content.scrollLeft();
    const scrollLeft = this.props.scrollLeft();

    // this is to handle an issue we saw with scaleManager
    // calculating pixel or 2 differences for rounding.
    if (
      scrollLeft >= contentScrollLeft + 1 ||
      scrollLeft <= contentScrollLeft - 1
    ) {
      this.content.scrollLeft(this.props.scrollLeft());
      this.scaleStickyHeader.scrollLeft(this.props.scrollLeft());
    }
  }

  componentDidUpdate() {
    this.slideIntoPlace();
  }

  componentWillUnmount() {
    $(window).off('resize.timelineControlTable');
    this.scaleStickyHeader.off('mousewheel.timelineControlTable');
    this.rowStickyHeaders.off('mousewheel.timelineControlTable');
    this.content.off('scroll.timelineControlTable');
  }

  debouncedOnResize() {
    const eventHandler = event => {
      if (event.target === window) {
        this.props.handleResize();
      }
    };

    if (this.props.viewOnly) {
      $(window).on('resize.timelineControlTable', eventHandler);
    } else {
      const debouncedEventHandler = debounce(eventHandler, 100);
      $(window).on('resize.timelineControlTable', debouncedEventHandler);
    }
  }

  onContentScroll(content) {
    content.on('scroll.timelineControlTable', () => this.handleScroll());
  }

  onMouseWheelScroll(element) {
    element.on('mousewheel.timelineControlTable', event => {
      this.content.scrollTop(
        this.content.scrollTop() - Math.round(event.deltaY * event.deltaFactor)
      );

      this.content.scrollLeft(
        this.content.scrollLeft() - Math.round(event.deltaX * event.deltaFactor)
      );

      return false;
    });
  }

  handleScroll() {
    this.scaleStickyHeader.scrollLeft(this.content.scrollLeft());
    this.rowStickyHeaders.scrollTop(this.content.scrollTop());

    if (
      !this.state.firstScroll &&
      (!this.props.viewOnly || this.props.dashboard)
    ) {
      this.props.updateScaleBarScroll();
    } else {
      this.setState({ firstScroll: false });
    }

    defer(() => {
      const hasScrolledTop = this.content.scrollTop() > 0;
      this.scaleStickyHeader.toggleClass('scroll-shadow', hasScrolledTop);
      this.stickyCorner.toggleClass('scroll-shadow-bottom', hasScrolledTop);

      const hasScrolledLeft = this.content.scrollLeft() > 0;
      this.rowStickyHeaders.toggleClass('scroll-shadow', hasScrolledLeft);
      this.stickyCorner.toggleClass('scroll-shadow-left', hasScrolledLeft);
    });
  }

  render() {
    return this.props.children;
  }
}
